unit NetInstrumentItemType;

interface

type
  TNetInstrumentItemType = class
  private
    fNetInstrumentKey: String;
    fInstrumentKey: String;
    fInstrumentName: String;
    fNetName: String;
    fAmountInNet: Byte;
    fIndexInNet: Byte;
    fToPin: Boolean;
  public
    property NetInstrumentKey: String read fNetInstrumentKey;
    property InstrumentKey: String read fInstrumentKey;
    property InstrumentName: String read fInstrumentName;
    property NetName: String read fNetName;
    property AmountInNet: Byte read fAmountInNet;
    property IndexInNet: Byte read fIndexInNet;
    property ToPin: Boolean read fToPin;
end;

implementation

end.
